import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterModule } from '@angular/router';
import { map } from 'rxjs/operators';

import { AuthService } from '../../services/auth.service';
import { NavbarService } from '../../services/navbar.service';
import { ProgressBarService } from '../../services/progress-bar.service';
import { SearchByIdModalComponent } from '../search-by-id-modal/search-by-id-modal.component';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatProgressBarModule,
    RouterModule,
    MatDialogModule,
  ],
})
export class NavbarComponent implements OnInit {
  public showToggleButton = this.router.events.pipe(
    map(() => {
      return !['/login', '/mfa'].some((path) =>
        this.router.url.startsWith(path),
      );
    }),
  );

  constructor(
    private dialog: MatDialog,
    private router: Router,
    public navbarService: NavbarService,
    public authService: AuthService,
    public progressBarService: ProgressBarService,
  ) {}

  ngOnInit(): void {}

  openSearch() {
    this.dialog.open(SearchByIdModalComponent);
  }
}
